<template>
  <v-form ref="form" v-model="formIsValid">
    <v-container fluid class="pa-0">
      <v-row align="start" justify="start" no-gutters>
        <v-col cols="12" xs="12" sm="5" md="4">
          <sl-text-field
            :type="passwordShow ? 'text' : 'password'"
            :rules="[rules.required, rules.min8chars]"
            :counter="passwordEditing"
            v-model="password"
            id="password"
            label="Enter the new password"
            name="password"
            required
            dense
            hint="At least 8 characters"
            @edit="passwordEditing = true"
            @edit-done="passwordEditing = false"
          >
            <v-icon v-show="passwordEditing" slot="append" @click="passwordShow = !passwordShow">
              {{ passwordShow ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
            </v-icon>
          </sl-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="5" md="4">
          <sl-text-field
            :type="passwordShow ? 'text' : 'password'"
            :rules="[rules.required, rules.min8chars, passwordsMatch]"
            v-model="passwordRepeated"
            id="passwordRepeated"
            label="Re-enter the password"
            name="passwordRepeated"
            required
            dense
            solo
            hint="At least 8 characters"
            :counter="passwordRepeatedEditing"
            @edit="passwordRepeatedEditing = true"
            @edit-done="passwordRepeatedEditing = false"
          >
            <v-icon
              v-show="passwordRepeatedEditing"
              slot="append"
              @click="passwordShow = !passwordShow"
            >
              {{ passwordShow ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
            </v-icon>
          </sl-text-field>
        </v-col>
        <v-col xs="12" sm="2" align="center">
          <!-- <v-btn :disabled="!formIsValid" icon large color="secondary" @click="passwordChange">
            <v-icon>mdi-check</v-icon>
          </v-btn> -->
          <v-btn :disabled="!formIsValid" color="secondary" outlined @click="passwordChange">
            Update
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
// import { mapState, mapMutations } from 'vuex'
import { mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import User from '@/models/User'

import SlTextField from '@/components/SlTextField'

export default {
  components: {
    SlTextField,
  },

  data: () => ({
    formIsValid: false,
    password: '',
    passwordEditing: false,
    passwordRepeated: '',
    passwordRepeatedEditing: false,
    rules: {
      required: v => !!v || 'Required',
      min8chars: v => (v && v.length >= 8) || 'Min 8 characters',
    },
    passwordShow: false,
  }),

  computed: {
    passwordsMatch: function() {
      return this.passwordRepeated === this.password || 'Passwords must match'
    },
    //
    // ...mapState(['userLogged']),
  },

  methods: {
    formReset() {
      // this.$refs.form.reset()
      this.password = ''
      this.passwordRepeated = ''
      this.$refs.form.resetValidation()
    },
    async passwordChange() {
      try {
        //this.$refs.form.validate();
        await User.passwordChange(this.password)
        // await User.passwordChange(this.userLogged, this.password)
        this.toastSet({
          message: 'Password succesfully updated',
          color: 'success',
        })
        this.formReset()
      } catch (e) {
        Logger.error(e)
        this.toastSet({
          message: 'Error in updating password',
          color: 'error',
        })
      }
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
